import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import { Link } from 'react-router-dom'
import NewMain from '../headerone/newMain'
import NewIqacSidebar from './NewIqacSidebar'

function Affiliation() {
  return (
    <>
    <style>{` .footer_main01  { display:none;      } `}</style>
      <div className='new_iqac'>
         
         <div className='row'>
             <div className='col-md-3'>
                    <NewIqacSidebar />
             </div>

             <div className='col-md-9'>
               <div className='home'>
                   <div className='about'>
                       <div className='row'>
                           <div className='col-md-12'>
                               <div className='text'>
                                   <h3>Affiliation and Ranking
                                   </h3>
                                   <div className='imgs'>
                                   <img src='/assets/img/affiliationbanner.jpg'></img>
                                 </div>
                               </div>
                               <br></br>
                               <div className='ranking'>
                                 
                                 <div className='table'>
                                   <table className='table table-bordered table-responsive composition-table'>
                                     <tbody>
                                       <tr>
                                         <td>Bar Council of India (BCI)</td>
                                         <td><a href="/assets/img/BAR-Council.pdf" target="_blank"><img src='/assets/img/pdficon.png'></img></a></td>
                                       </tr>
                                       <tr>
                                         <td>Haryan State Physiotherapy Council (HSPC) </td>
                                         <td><a href="/assets/img/State-Council-for-Physiotherapy.pdf" target="_blank"><img src='/assets/img/pdficon.png'></img></a></td>
                                       </tr>
                                       <tr>
                                         <td>Pharma Council of India (PCI) </td>
                                         <td><a href="" target="_blank"><img src='/assets/img/pdficon.png'></img></a></td>
                                       </tr>
                                     </tbody>
                                   </table>
                                 </div>
                               </div>
                           </div>
                       </div>
                   </div>
                 
               </div>
             </div>


         </div>

    

 </div>

    </>
  )
}

export default Affiliation